import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

import UserList from "../pages/Masters/Users/userList";
import UserCreate from "../pages/Masters/Users/UserCreate";
import UserView from "../pages/Masters/Users/UserView";

import RoleView from "../pages/Masters/Role/RoleView";
import RoleList from "../pages/Masters/Role/RoleList";
import RoleCreate from "../pages/Masters/Role/RoleCreate";
import MenuList from "../pages/Masters/Menu/MenuList";
import MenuCreate from "../pages/Masters/Menu/MenuCreate";
import MenuView from "../pages/Masters/Menu/MenuView";
import UserMenuAccess from "../pages/Access/UserMenuAccess/UserMenuAccess";
import CountryView from "../pages/Masters/Country/CountryView";
import CountryList from "../pages/Masters/Country/CountryList";
import CountryCreate from "../pages/Masters/Country/CountryCreate";
import StateView from "../pages/Masters/State/StateView";
import StateList from "../pages/Masters/State/StateList";
import StateCreate from "../pages/Masters/State/StateCreate";
import CityView from "../pages/Masters/City/CityView";
import CityList from "../pages/Masters/City/CityList";
import CityCreate from "../pages/Masters/City/CityCreate";
import UOMView from "../pages/Masters/UOM/UOMView";
import UOMList from "../pages/Masters/UOM/UOMList";
import UOMCreate from "../pages/Masters/UOM/UOMCreate";
import CategoryView from "../pages/Masters/Category/CategoryView";
import CategoryList from "../pages/Masters/Category/CategoryList";
import CategoryCreate from "../pages/Masters/Category/CategoryCreate";
import MaterialView from "../pages/Masters/Item/ItemView";
import MaterialList from "../pages/Masters/Item/ItemList";
import MaterialCreate from "../pages/Masters/Item/ItemCreate";
import BranchView from "../pages/Masters/Branch/BranchView";
import BranchList from "../pages/Masters/Branch/BranchList";
import BranchCreate from "../pages/Masters/Branch/BranchCreate";
import ScrapReasonView from "../pages/Masters/ScrapReason/ScrapReasonView";
import ScrapReasonList from "../pages/Masters/ScrapReason/ScrapReasonList";
import ScrapReasonCreate from "../pages/Masters/ScrapReason/ScrapReasonCreate";

import MaterialApproval from "../pages/MaterialApproval/MaterialApproval";
import SparePartRequestView from "../pages/SparePartRequests/SparePartRequestView";
import SparePartRequestList from "../pages/SparePartRequests/SparePartRequestList";
import SparePartRequestCreate from "../pages/SparePartRequests/SparePartRequestCreate";
import SparePartIssues from "../pages/SparePartIssues/SparePartIssuesCreate";
import SparePartIssuesCreate from "../pages/SparePartIssues/SparePartIssuesCreate";
import SparePartIssuesList from "../pages/SparePartIssues/SparePartIssuesList";
import SparePartIssuesView from "../pages/SparePartIssues/SparePartIssuesView";
import JobCardView from "../pages/JobCard/JobCardView";
import JobCardList from "../pages/JobCard/JobCardList";
import JobCardCreate from "../pages/JobCard/JobCardCreate";
import ScrapView from "../pages/Scrap/ScrapView";
import ScrapList from "../pages/Scrap/ScrapList";
import ScrapCreate from "../pages/Scrap/ScrapCreate";
import DispatchedList from "../pages/Dispatched/DispatchedList";
import DispatchedCreate from "../pages/Dispatched/DispatchedCreate";
import DispatchedView from "../pages/Dispatched/DispatchedView";
import OEMView from "../pages/Masters/OEM/OEMView";
import OEMList from "../pages/Masters/OEM/OEMList";
import OEMCreate from "../pages/Masters/OEM/OEMCreate";
import GroupView from "../pages/Masters/Group/GroupView";
import GroupList from "../pages/Masters/Group/GroupList";
import GroupCreate from "../pages/Masters/Group/GroupCreate";
import ItemView from "../pages/Masters/Item/ItemView";
import ItemList from "../pages/Masters/Item/ItemList";
import ItemCreate from "../pages/Masters/Item/ItemCreate";
import ItemIntakeView from "../pages/Masters/ItemIntakes/ItemIntakeView";
import ItemIntakeList from "../pages/Masters/ItemIntakes/ItemIntakeList";
import ItemIntakeCreate from "../pages/Masters/ItemIntakes/ItemIntakeCreate";
import SparePartInventoryCreate from "../pages/SparePartInventory/SparePartInventoryCreate";
import SparePartInventoryList from "../pages/SparePartInventory/SparePartInventoryList";
import SparePartInventoryView from "../pages/SparePartInventory/SparePartInventoryView";
import ViewStock from "../pages/ViewStock/ViewStock";
import TechnicianInventoryCreate from "../pages/TechnicianInventory/TechnicianInventoryCreate";
import TechnicianInventoryList from "../pages/TechnicianInventory/TechnicianInventoryList";
import TechnicianInventoryView from "../pages/TechnicianInventory/TechnicianInventoryView";

import TechnicianStockReturnCreate from "../pages/TechnicianStockReturn/TechnicianStockReturnCreate";
import TechnicianStockReturnList from "../pages/TechnicianStockReturn/TechnicianStockReturnList";
import TechnicianStockReturnView from "../pages/TechnicianStockReturn/TechnicianStockReturnView";
import TechnicianRepair from "../pages/JobCard/TechnicianRepair";
import ZoneView from "../pages/Masters/Zone/ZoneView";
import ZoneList from "../pages/Masters/Zone/ZoneList";
import ZoneCreate from "../pages/Masters/Zone/ZoneCreate";
import UserTypeAccess from "../pages/Access/UserTypeAccess/UserTypeAccess";

const createRoute = (path, component) => ({ path, component });

const routes = [
  createRoute("/dashboard", <Dashboard />),
  //access
  createRoute("/user-role-access/:id?", <UserTypeAccess />),
  createRoute("/user-menu-access/:id?", <UserMenuAccess />),

  //masters
  //user
  createRoute("/user-list", <UserList />),
  createRoute("/user-create/:id?", <UserCreate />),
  createRoute("/user-view/:id?", <UserView />),

  //role
  createRoute("/role-view/:id?", <RoleView />),
  createRoute("/role-list", <RoleList />),
  createRoute("/role-create/:id?", <RoleCreate />),

  //menu
  createRoute("/menu-list", <MenuList />),
  createRoute("/menu-create/:id?", <MenuCreate />),
  createRoute("/menu-view/:id?", <MenuView />),

  //country
  createRoute("/country-view/:id?", <CountryView />),
  createRoute("/country-list", <CountryList />),
  createRoute("/country-create/:id?", <CountryCreate />),

  //state
  createRoute("/state-view/:id?", <StateView />),
  createRoute("/state-list", <StateList />),
  createRoute("/state-create/:id?", <StateCreate />),

  //city
  createRoute("/city-view/:id?", <CityView />),
  createRoute("/city-list", <CityList />),
  createRoute("/city-create/:id?", <CityCreate />),

  //UOM
  createRoute("/uom-view/:id?", <UOMView />),
  createRoute("/uom-list", <UOMList />),
  createRoute("/uom-create/:id?", <UOMCreate />),

  //Category
  createRoute("/category-view/:id?", <CategoryView />),
  createRoute("/category-list", <CategoryList />),
  createRoute("/category-create/:id?", <CategoryCreate />),

  //item
  createRoute("/item-view/:id?", <ItemView />),
  createRoute("/item-list", <ItemList />),
  createRoute("/item-create/:id?", <ItemCreate />),

  //Branch
  createRoute("/branch-view/:id?", <BranchView />),
  createRoute("/branch-list", <BranchList />),
  createRoute("/branch-create/:id?", <BranchCreate />),

  //Scrap Reason
  createRoute("/scrap-reason-view/:id?", <ScrapReasonView />),
  createRoute("/scrap-reason-list", <ScrapReasonList />),
  createRoute("/scrap-reason-create/:id?", <ScrapReasonCreate />),

  //OEM
  createRoute("/oem-view/:id?", <OEMView />),
  createRoute("/oem-list", <OEMList />),
  createRoute("/oem-create/:id?", <OEMCreate />),

  //Group
  createRoute("/group-view/:id?", <GroupView />),
  createRoute("/group-list", <GroupList />),
  createRoute("/group-create/:id?", <GroupCreate />),

  //Zone
  createRoute("/zone-view/:id?", <ZoneView />),
  createRoute("/zone-list", <ZoneList />),
  createRoute("/zone-create/:id?", <ZoneCreate />),

  //Material Intakes
  createRoute("/item-intakes-view/:id?", <ItemIntakeView />),
  createRoute("/item-intakes-list", <ItemIntakeList />),
  createRoute("/item-intakes-create/:id?", <ItemIntakeCreate />),

  createRoute("/material-approval", <MaterialApproval />),

  //job card
  createRoute("/job-card-list", <JobCardList />),
  createRoute("/job-card-view/:id?", <JobCardView />),
  createRoute("/job-card-create/:id?", <JobCardCreate />),
  createRoute("/job-card-technician-repair/:id?", <TechnicianRepair />),

  //Spare Part Requests
  createRoute("/spare-part-requests-view/:id?", <SparePartRequestView />),
  createRoute("/spare-part-requests-list", <SparePartRequestList />),
  createRoute("/spare-part-requests-create/:id?", <SparePartRequestCreate />),

  //Spare Part Issues
  createRoute("/spare-part-issues-view/:id?", <SparePartIssuesView />),
  createRoute("/spare-part-issues-list", <SparePartIssuesList />),
  createRoute("/spare-part-issues-create/:id?", <SparePartIssuesCreate />),
  //Scrap
  createRoute("/scrap-view/:id?", <ScrapView />),
  createRoute("/scrap-list", <ScrapList />),
  createRoute("/scrap-create/:id?", <ScrapCreate />),

  //dispatch
  createRoute("/dispatched-list", <DispatchedList />),
  createRoute("/dispatched-view/:id?", <DispatchedView />),
  createRoute("/dispatched-create/:id?", <DispatchedCreate />),
  //SparePartInventory
  createRoute(
    "/spare-part-inventory-create/:id?",
    <SparePartInventoryCreate />
  ),
  createRoute("/spare-part-inventory-list", <SparePartInventoryList />),
  createRoute("/spare-part-inventory-view/:id?", <SparePartInventoryView />),

  //TechnicianInventory
  createRoute(
    "/technician-inventory-create/:id?",
    <TechnicianInventoryCreate />
  ),
  createRoute("/technician-inventory-list", <TechnicianInventoryList />),
  createRoute("/technician-inventory-view/:id?", <TechnicianInventoryView />),

  //TechnicianStockReturn
  createRoute(
    "/technician-stock-return-create/:id?",
    <TechnicianStockReturnCreate />
  ),
  createRoute("/technician-stock-return-list", <TechnicianStockReturnList />),
  createRoute(
    "/technician-stock-return-view/:id?",
    <TechnicianStockReturnView />
  ),

  //View Stock
  createRoute("/view-stock", <ViewStock />),
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const paginationRoute = routes
  .filter((route) =>
    [
      "/user-list",
      "/menu-list",
      "/job-card-list",
      "/spare-part-requests-list",
      "/item-intakes-list",
      "/dispatched-list",
      "/scrap-list",
      "/spare-part-issues-list",
      "/scrap-reason-list",
      "/country-list",
      "/city-list",
      "/category-list",
      "/uom-list",
      "/branch-list",
      "/state-list",
      "/role-list",
      "/item-list",
      "/spare-part-inventory-list",
      "/technician-inventory-list",
      "/technician-stock-return-list",
      "/oem-list",
      "/group-list",
      "/zone-list",
    ].includes(route.path)
  )
  .map((route) => route.path);

export { routes, paginationRoute };
